/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：160
 */

module.exports = {
  cloudDBManager: "styles_cloudDBManager__23tv1",
  managerTitle: "styles_managerTitle__2-kh8",
  titleText: "styles_titleText__Vb4Mc",
  container: "styles_container__2Rj5i",
  left: "styles_left__fu4Cm",
  capacity: "styles_capacity__1AZso",
  header: "styles_header__2G-i1",
  text1: "styles_text1__2pPTE",
  text2: "styles_text2__15QEm",
  data: "styles_data__1zveM",
  dataDev: "styles_dataDev__3WpQj",
  dataProd: "styles_dataProd__2cJrk",
  description: "styles_description__2GZrD",
  point: "styles_point__LtswI",
  text: "styles_text__2-NbV",
  dev: "styles_dev__1eRP3",
  prod: "styles_prod__2LAg8",
  line: "styles_line__26g5K",
  DBData: "styles_DBData__3Ij4K",
  item: "styles_item__3JiEY",
  hasImport: "styles_hasImport__2Lc_l",
  import: "styles_import__28kJ4",
  selected: "styles_selected__xW063",
  right: "styles_right__R-Xb4",
  tabs: "styles_tabs__2kkND",
  tab: "styles_tab__dHN-r",
  selected_dev: "styles_selected_dev__1k76B",
  selected_prod: "styles_selected_prod__1JzYI",
  gridArea: "styles_gridArea__30IIn",
  loading: "styles_loading__2aQOs",
  popoverWrapper: "styles_popoverWrapper__ysFX9",
  menuItem: "styles_menuItem__w1sR0",
  delete: "styles_delete__syqeC",
  list: "styles_list__38KGI",
  name: "styles_name__3f-LM",
  edit: "styles_edit__2K0Qa",
  icon: "styles_icon__3oDq1",
  itemWrapper: "styles_itemWrapper__1-4Cp",
  noData: "styles_noData__1RvWz",
  listItem: "styles_listItem__2lDHg",
  row: "styles_row__wPEgB",
  column: "styles_column__3F2nB",
  columnArea: "styles_columnArea__3W9To",
  columnIcon: "styles_columnIcon__2_84K",
  emptyContainer: "styles_emptyContainer__zCOfW"
}
